var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_1078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_1078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 15.1125V9.31873L3.375 6.39373V12.1875L8.4375 15.1125ZM9.5625 15.1125L14.625 12.1875V6.37498L9.5625 9.31873V15.1125ZM8.4375 16.4062L2.8125 13.1625C2.6375 13.0625 2.5 12.925 2.4 12.75C2.3 12.575 2.25 12.3875 2.25 12.1875V5.81248C2.25 5.61248 2.3 5.42498 2.4 5.24998C2.5 5.07498 2.6375 4.93748 2.8125 4.83748L8.4375 1.59373C8.6125 1.49373 8.8 1.44373 9 1.44373C9.2 1.44373 9.3875 1.49373 9.5625 1.59373L15.1875 4.83748C15.3625 4.93748 15.5 5.07498 15.6 5.24998C15.7 5.42498 15.75 5.61248 15.75 5.81248V12.1875C15.75 12.3875 15.7 12.575 15.6 12.75C15.5 12.925 15.3625 13.0625 15.1875 13.1625L9.5625 16.4062C9.3875 16.5062 9.2 16.5562 9 16.5562C8.8 16.5562 8.6125 16.5062 8.4375 16.4062ZM12.075 6.56248L13.9875 5.45623L9 2.56873L7.0875 3.67498L12.075 6.56248ZM9 8.36248L10.95 7.21873L5.94375 4.33123L3.99375 5.45623L9 8.36248Z",
    fill: "#8A6CAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage2);
export default __webpack_public_path__ + "static/media/package_2.69bf9d1b31b42ded2b41d32ff4a1d0e9.svg";
export { ForwardRef as ReactComponent };